// src/services/api.ts
import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  withCredentials: true
});

// optional: tiny helper to normalize any error into apiError
const normalizeError = (error) => {
  // no response at all (network error, timeout, cors, etc)
  if (!error.response) {
    return {
      message: 'unable to connect to server.',
      errors: ['network error'],
      status: undefined
    };
  }

  const { status, data } = error.response;

  // if server already returned your apierror shape
  if (data && typeof data === 'object') {
    const message =
      typeof data.message === 'string' && data.message.trim().length > 0
        ? data.message
        : 'an unexpected error occurred.';

    const errors = Array.isArray(data.errors)
      ? data.errors.filter((e) => typeof e === 'string')
      : undefined;

    return {
      status,
      message,
      errors
    };
  }

  // if server returned a plain string body
  if (typeof data === 'string') {
    return {
      status,
      message: data || 'an unexpected error occurred.',
      errors: undefined
    };
  }

  // final fallback
  return {
    status,
    message: 'an unexpected error occurred.',
    errors: undefined
  };
};

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const apiErr = normalizeError(error);

    // if you want global logging, do it here
    // console.error('api error', apiErr);

    // if you want global ui notifications, you could also trigger them here
    // notification.error({ message: apiErr.message });

    return Promise.reject(apiErr);
  }
);

export default api;
